export default __webpack_public_path__ + "static/media/ic_arbitrum_96.b12913b6.svg";